export const SURVEY_TYPE = {
  text: "Textbox",
  binary: "Yes/No",
  singleChoice: "Single Choice",
  multipleChoice: "Multiple Choice",
  scale: "Opinion Scale",
  file: "File Upload",
};
